import axios from 'axios';
import commonInterceptors from '@/interceptors/commonInterceptors.interceptor.js';

const pixAxios = axios.create();

commonInterceptors.setCommonInterceptors(pixAxios);

export default pixAxios;
